import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import {UserType} from '../../domain/User';
import {UserService} from '../../services/user/user.service';
import {NavigationService} from '../../services/nav/navigation.service';
import {UserDto} from '@api/utisha-backend';
import UserTypeEnum = UserDto.UserTypeEnum;

@Injectable({
  providedIn: 'root'
})
export class TeacherSignupGuard  {
  loggedIn: boolean;

  constructor(private userService: UserService,
              private navService: NavigationService) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    this.userService.intentUserType = UserTypeEnum.Teacher;
    this.navService.signup();
    return Promise.resolve(true);
  }
}
